"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceCostsPerContractBase = void 0;
const tslib_1 = require("tslib");
const apigw_models_1 = require("@integration/apigw-models");
const class_validator_1 = require("class-validator");
const decorators_1 = require("../../decorators");
const enums_1 = require("../enums");
class PriceCostsPerContractBase extends apigw_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsEnum)(enums_1.EnergyType),
    (0, class_validator_1.IsDefined)(),
    (0, decorators_1.ExposeNameCase)(decorators_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, apigw_models_1.Docs)({ description: 'Energy type of this contract', example: enums_1.EnergyType.ELECTRICITY }),
    tslib_1.__metadata("design:type", String)
], PriceCostsPerContractBase.prototype, "energyType", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, decorators_1.ExposeNameCase)(decorators_1.ExposeNameCaseEnum.SNAKE_CASE),
    (0, apigw_models_1.Docs)({ description: 'Id of this contract', example: '4029683130' }),
    tslib_1.__metadata("design:type", String)
], PriceCostsPerContractBase.prototype, "contractId", void 0);
exports.PriceCostsPerContractBase = PriceCostsPerContractBase;
